import {useEffect} from 'react';

import appConfig from '../configs/appConfig';
import appService from '../services/appService';
import awsAuthService from '../services/aws/awsAuthService';
import awsClient from '../services/aws/awsClient';
import localizationControllerService from '../services/localization/localizationControllerService';
import serviceWorkerService from '../services/serviceWorkerService';
import {userBrowserService} from '../services/userBrowserService';
import {setIsAppInitialized} from '../state/slice/global';
import {dispatch} from '../state/store';
import useInitRoute from './useInitRoute';

const useInitApp = () => {
    const initRoute = useInitRoute();

    const configure = async () => {
        const config = appConfig.getAwsAmplifyConfig();

        awsClient.configure(config);
        appService.updatePWAStatus();
        userBrowserService.updateHighEntropyOSVersion();

        await Promise.allSettled([
            localizationControllerService.initializeLocalization(),
            awsAuthService.checkAuthorization(),
        ]);

        initRoute();

        serviceWorkerService.subscribeToSWMessages(); // Redirect from push notification

        dispatch(setIsAppInitialized(true));
    };

    useEffect(() => {
        configure();
    }, []);
};

export default useInitApp;
